/**
 * Require axios module
 */
import axios from 'axios';

/**
 * Create axios instance
 */
let axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_DOMAIN + process.env.VUE_APP_API_PATH,
});

/**
 * Export
 */
export default axiosInstance;
